import React, { useState } from "react";
import { NavLink, useLocation, useHistory } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../assets/images/logo.png";
import { menuData } from "../data/header";
import SymbolSearchDialog from "../components/SymbolSearchDialog";
import PSXTicker from "../components/PSXTicker";

function HeaderNavigation() {
  const location = useLocation();
  const history = useHistory();
  const [searchOpen, setSearchOpen] = useState(false);

  const handleSymbolSelect = (item) => {
    history.push(`/trading-dashboard/${item.code}`);
  };

  return (
    <>

      {/* ══ BAND 1: Logo + Contact + CTA ══ */}
      <div className="hdr-top">
                {/* ══ BAND 0: Live ticker strip ══ */}
    <div className="hdr-ticker-band">
      <PSXTicker />
    </div>
        <div className="hdr-top-inner">

          {/* Logo */}
          <a href="/" className="hdr-logo-link">
            <img src={logo} alt="Orbit Securities" className="hdr-logo" />
          </a>

          {/* Right side: contacts + open account */}
          <div className="hdr-top-right">

            {/* Call Us box */}
            <div className="hdr-callus">
              <div className="hdr-callus-label">Call Us</div>
              <div className="hdr-callus-numbers">
                <span className="hdr-phone">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/>
                  </svg>
                  +92-333-529-9115
                </span>
                <span className="hdr-phone">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
                    <path d="M11.999 0C5.372 0 0 5.373 0 12c0 2.117.554 4.104 1.523 5.827L0 24l6.335-1.502A11.93 11.93 0 0012 24c6.627 0 12-5.373 12-12S18.626 0 12 0zm0 21.818a9.818 9.818 0 01-5.002-1.366l-.36-.214-3.76.891.946-3.658-.235-.375A9.818 9.818 0 012.182 12c0-5.424 4.393-9.818 9.817-9.818 5.425 0 9.818 4.394 9.818 9.818 0 5.425-4.393 9.818-9.818 9.818z"/>
                  </svg>
                  +92-333-529-9115
                </span>
              </div>
            </div>

            <div className="hdr-vert-divider" />

            {/* Open Account */}
            <div className="hdr-account-group">
              <div className="hdr-account-label">Open New Account</div>
              <div className="hdr-account-btns">
                <a
                  href="https://www.asaanconnect.com/cdc/cgp/r/centralized-gateway-portal/home"
                  target="_blank" rel="noopener noreferrer"
                  className="hdr-btn-solid"
                >
                  Via CDC
                </a>
                <a
                  href="https://www.aof.com.pk/?MTg2MjgyNTQzNzY0OTc5MjI4MzQyODYyNTI1NDY4NjQ4NDYyNzcyNw=="
                  target="_blank" rel="noopener noreferrer"
                  className="hdr-btn-outline"
                >
                  Via Orbit
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ══ BAND 2: Nav menu + Search ══ */}
      <div className="hdr-nav-band">
        <div className="hdr-nav-inner">
          <Navbar expand="lg" className="hdr-navbar">
            <Navbar.Toggle aria-controls="hdr-nav-collapse" className="hdr-toggler" />
            <Navbar.Collapse id="hdr-nav-collapse">
              <Nav className="hdr-nav-links">
                {menuData.map((menu, index) => {
                  const isActive = menu.items.some(item => location?.pathname === item.link);
                  return (
                    <NavDropdown
                      key={index}
                      className="hdr-dropdown"
                      title={
                        <span className={`hdr-nav-title${isActive ? " hdr-nav-active" : ""}`}>
                          {menu.title}
                        </span>
                      }
                      id={`hdr-dd-${index}`}
                    >
                      {menu.items.map((item, i) => (
                        <NavDropdown.Item
                          key={i}
                          as={NavLink}
                          to={item.link}
                          className={({ isActive }) =>
                            `hdr-dd-item${isActive ? " hdr-dd-active" : ""}`
                          }
                        >
                          {item.label}
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  );
                })}
              </Nav>

              {/* Search — pushed to far right */}
              <button
                className="hdr-search-btn"
                onClick={() => setSearchOpen(true)}
                aria-label="Search stock symbols"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2.2"
                  strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="11" cy="11" r="8"/>
                  <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                Search symbols
              </button>

            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>

      <SymbolSearchDialog
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onSelect={handleSymbolSelect}
      />
    </>
  );
}

export default HeaderNavigation;